import React from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { MaskedLink } from '@hz-design-system/web-ui';

import { GA_PARAMETER, GA_TRACK_EVENTS_ACTIONS } from '../../../utils/constants';
import createCustomDimension from '../../../utils/createCustomDimension';
import { trackGAEvent } from '../../../utils/gaTracking';

import Classes from './SellerWebsiteLink.module.scss';
import { TListingClient } from 'types/TListing';

type TSellerWebsiteLinkProps = {
  seller: TListingClient['seller'];
};

const SellerWebsiteLink = ({ seller }: TSellerWebsiteLinkProps) => {
  const { sellerWebsiteDisplayUrl, sellerWebsiteUrl, sellerType } = seller;

  if (!sellerWebsiteDisplayUrl || !sellerWebsiteUrl) {
    return null;
  }

  const handleClick = () => {
    if (sellerType) {
      trackGAEvent(GA_TRACK_EVENTS_ACTIONS.R2SExternalBegin, 'description', {
        ...createCustomDimension({ dimension: GA_PARAMETER.AD_SELLER_TYPE, payload: sellerType }),
      });
    }
  };

  return (
    <>
      <Trans className={Classes.title} tagName="h3" i18nKey="sellerContact.website" />
      <MaskedLink href={sellerWebsiteUrl} onClick={handleClick} target="_blank" rel="nofollow" className={Classes.link}>
        {sellerWebsiteDisplayUrl}
      </MaskedLink>
    </>
  );
};

export default SellerWebsiteLink;
